import FormGroup from 'features/shared/forms/components/FormGroup';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  name: string;
  bindField: any;
  editable: boolean;
  errors?: Record<string, string>;
}

const SelfReadingMeter = ({ name, bindField, editable, errors }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // render
  if (editable) {
    return (
      <FormGroup labelText={tLabels("selfReadingMeter.meterNumber")} inputId={name} validationError={errors ? errors[name] : undefined}>
        <input className="form-control" id={name} {...bindField(name)} placeholder={tLabels("selfReadingMeter.setMeterNumber")} />
      </FormGroup>
    )
  } else {
    return null;
  }
}

export default SelfReadingMeter;
